import React, { useRef,  Component , useEffect} from "react";
import TradingViewWidget, { Themes } from "react-tradingview-widget";
import { convertNameToTradingviewSybmol } from "../../utils/nameSymbol";
import { useState } from "react";

const winWidth = window.innerWidth;
const winHeight = window.innerHeight;

function Widget(props) {
  // var clientWidth = document.getElementsByClassName("Widget").clientWidth;
  // var clientHeight = document.getElementsByClassName("Widget").clientHeight;

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  
  useEffect(()=>{
      if (winWidth > 640) {
        setWidth(Math.floor(winWidth * 0.65));
        setHeight(Math.floor(winHeight * 0.75));
      } else if (winWidth <= 640) {
        setWidth(Math.floor(winWidth * 0.90));
        setHeight(Math.floor(winHeight * 0.60));
      }
   }, []);

  console.log(width*0.7);
  console.log(height);

  return (
    <div className="widget-class">
      <TradingViewWidget
        symbol={convertNameToTradingviewSybmol(props.coinSelectedName)}
        width={width}
        height={height}
        timezone="Asia/Kolkata"
        locale="in"
        style="2"
        theme={Themes.DARK}
        range="12m"
        // toolbar_bg = "#f1f3f6"
        allow_symbol_change={false}
        details={true}
        studies={["MASimple@tv-basicstudies"]}
        // hotlist = {true}
        // calendar = {true}
      />
    </div>
  );
}

export default React.memo(Widget);
